// Zentrale Registrierung aller Web-Komponenten
// Diese Datei sollte alle verfügbaren Komponenten importieren und registrieren

import { registerWebComponents } from './useWebComponents'
import type { WebComponentConfig } from '../types/webComponents'

/**
 * Lädt alle Web-Komponenten und gibt die Konfigurationen zurück
 */
export async function getAllWebComponents(): Promise<WebComponentConfig[]> {
  const components: WebComponentConfig[] = []

  try {
    // Beispiel-Komponente: HelloWorld
    const { default: HelloWorld } = await import('../components/HelloWorld.ce.vue')
    components.push({
      component: HelloWorld,
      tagName: 'hello-world',
    })

    const { default: HelloWorld2 } = await import('../components/HelloWorld2.ce.vue')
    components.push({
      component: HelloWorld2,
      tagName: 'hello-world-2',
    })

    const { default: OnlineSurvey } = await import('../components/OnlineSurvey.ce.vue')
    components.push({
      component: OnlineSurvey,
      tagName: 'online-survey',
    })
  } catch (error) {
    console.error('Fehler beim Laden der Web-Komponenten:', error)
  }

  return components
}

/**
 * Registriert alle Web-Komponenten
 */
export async function registerAllWebComponents(): Promise<void> {
  const components = await getAllWebComponents()
  registerWebComponents(components)
  console.log(`${components.length} Web-Komponenten registriert`)
}

/**
 * Registriert eine einzelne Komponente nach Tag-Namen
 */
export async function registerComponentByName(tagName: string): Promise<boolean> {
  const components = await getAllWebComponents()
  const component = components.find((c) => c.tagName === tagName)

  if (component) {
    registerWebComponents([component])
    return true
  }

  console.warn(`Komponente mit Tag-Name '${tagName}' nicht gefunden`)
  return false
}
